// @flow strict
const labels = {
  en: ['Loading…', 'Reload page', 'Some interactive controls could not be loaded.'],
  de: [
    'Wird geladen…',
    'Seite neu laden',
    'Einige interaktive Funktionen konnten nicht geladen werden.',
  ],
  it: [
    'Caricamento…',
    'Ricarica la pagina',
    'Non è stato possibile caricare alcune funzioni interattive.',
  ],
  es: [
    'Cargando…',
    'Volver a cargar la página',
    'No se pudieron cargar algunas funciones interactivas.',
  ],
  fr: [
    'Chargement…',
    'Recharger la page',
    'Certaines fonctions interactives n’ont pas pu être chargées.',
  ],
  pl: [
    'Ładowanie…',
    'Odśwież stronę',
    'Nie udało się załadować niektórych funkcji interaktywnych.',
  ],
  pt: [
    'A carregar…',
    'Recarregar a página',
    'Não foi possível carregar algumas funções interativas.',
  ],
  cs: ['Načítání…', 'Načíst stránku znovu', 'Některé interaktivní funkce se nepodařilo načíst.'],
  hu: ['Betöltés…', 'Oldal újratöltése', 'Néhány interaktív funkciót nem sikerült betölteni.'],
  nl: [
    'Laden…',
    'Pagina opnieuw laden',
    'Sommige interactieve functies konden niet worden geladen.',
  ],
  tr: ['Yükleniyor…', 'Sayfayı yeniden yükle', 'Bazı etkileşimli işlevler yüklenemedi.'],
  ro: ['Se încarcă…', 'Reîncarcă pagina', 'Unele funcții interactive nu au putut fi încărcate.'],
};

export default function routeLoadingLabels(language: string) {
  const [loading, reload, unavailable] = labels[language] || labels.en;
  return { loading, reload, unavailable };
}
